<template>
  <!-- TODO: Could not figure out how else to remove the app bar using cloudprints and onsite and having a work package open... -->
  <v-app-bar height="48px" app :style="`${isCloudPrint ? 'z-index: 0': ''}`">
    <template v-if="!is_logged_in && !isCloudPrint" >
      <div class="title primary--text">
        {{$t('AppLayout.NavBar.Mobile.Title[0]')}}
      </div>
      <div class="title font-weight-thin ml-1">
        {{$t('AppLayout.NavBar.Mobile.Title[1]')}}
      </div>
      <v-spacer/>
      <div class="version-token t-rounded footer-content font-weight-light">
        {{$t('AppLayout.NavBar.Mobile.VersionToken')}}
      </div>
      <span class="version-number ml-1 footer-content font-weight-light">
        v{{version_number}}
      </span>
    </template>

    <template v-else-if="getUseOnSite">
      <!-- @touchstart.native="back_loading = true" -->
      <div class="mobile-header-projectoverview-back">
        <BackButton
          :disabled="isCloudPrint"
          @backBtnClicked="$router.push({name: 'ProjectOverView'})"
          style="margin-left: -12px; flex-shrink: 0"
        >
          <template #text>
            <TText
              value="back"
              :size="14"
              style="padding-right: 14px"
            />
          </template>
        </BackButton>
        <TText
          :text="project.name"
          large
          font_weight="500"
          max_lines="1"
        />
      </div>
    </template>

    <template v-else>
      <div
        class="mobile-header-project-back"
        @touchstart="back_loading = true"
        @click="$router.push({name: 'ProjectOverView'})"
      >
        <v-icon v-if="!back_loading">
          keyboard_arrow_left
        </v-icon>
        <v-progress-circular v-else indeterminate/>
      </div>
      <v-tabs
        grow
        :value="getTabValue()"
      >
        <v-tab
          @click="$router.push({
            name: 'ProjectWallet',
            params: {
              takt_index: getCurrentTaktIndex($route.params.project_id) !== false?
                        Math.abs(getCurrentTaktIndex($route.params.project_id)):1
              }
            })"
        >
          wallet
          <!-- TAKT.wallet -->
        </v-tab>
        <v-tab
          @click="$router.push({
            name: 'ProjectTaktPlan',
            })"
        >
            plan
            <!-- TAKT.plan -->
        </v-tab>
        <v-tab
          v-if="hasProjectPermission({
                  project_id: $route.params.project_id,
                  ppermission: 'Read Invites'
                })"
          @click="$router.push({
            name: 'ProjectSettings',
            })"
        >
          settings
          <!-- TAKT.plan -->
        </v-tab>
      </v-tabs>
    </template>
  </v-app-bar>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppNavigationMixin } from '@/mixins/AppNavigation.mixin.js'
import BackButton from '@/components/WorkPackageWIP/BackButton.component.vue';

export default {
    props: ['is_logged_in'],

    mixins: [
      AppNavigationMixin
    ],

    components: {
      BackButton,
    },

    data: () => ({
      version_number: '',
      back_loading: false,
    }),

    created(){
      let json = require('../../../package.json');
      this.version_number = json.version
    },

    computed: {
      ...mapGetters('Project', [
        'hasProjectPermission',
      ]),

      ...mapGetters('View',[
        'getUseOnSite'
      ]),

      ...mapGetters('Auth',[
        'isCloudPrint'
      ]),

      project() {
        return this.$store.state.Ultra.projects[this.$route.params.project_id];
      },
    },

    methods: {
      getTabValue(){
        if (this.$route.matched[1]) {
          switch (this.$route.matched[1].name) {
            case 'ProjectWallet':
              return 0;
            case 'ProjectTaktPlan':
              return 1;
            case 'ProjectSettings':
              return 2;
          }
        }
      }
    },
  }
</script>
<style scoped>
.version-token {
  display: flex;
  height: 20px;
  width: 20px;
  border: solid 1px var(--v-primary-base);
  justify-content: center;
  align-items: center;
  font-size: 12px;
margin-right: 2px;
}
.version-number {
  font-size: 16px;
}
.mobile-header-project-back {
  margin-left: -16px;
  display: flex;
  width: 60px;
  justify-content: center;
}
.mobile-header-projectoverview-back {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
